<template>
	<div class="menu" :class="{ 'toggled': toggled }"></div>
</template>

<script>
	export default {
		data() {
			return {
				toggled: false
			};
		},

		watch: {
			toggled() {
				let appName = 'TESTE'.replace(/\s/g, '_');
				localStorage.setItem(`${appName}-menu-toggled`, this.toggled);
			}
		},

		created() {
			let appName = 'TESTE'.replace(/\s/g, '_');
			let value = localStorage.getItem(`${appName}-menu-toggled`);

			if (value) {
				this.toggled = JSON.parse(value);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.menu {
		position: relative;

		&.toggled {
			a:not(.handle):hover {
				.tooltip {
					display: inline-block !important;
				}
			}
		}

		.handler {
			height: 70px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #ffffff;
			font-size: 18px;
			cursor: pointer;
		}

		a {
			display: flex;
			align-items: center;
			text-decoration: none;
			color: darken(#ffffff, 0.5);
			transition: all 300ms;
			padding: 10px 15px;
			position: relative;

			.fa {
				font-size: 20px;
			}

			&:hover,
			&.active {
				color: lighten(#5bc0de, 10);
			}

			&.active:after {
				content: '';
				position: absolute;
				right: -15px;
				border: 6px solid transparent;
				border-right-color: #e7e7e7;
				cursor: default;
			}

			.tooltip {
				display: none;
				position: absolute;
				white-space: nowrap;
				left: 45px;
				z-index: 1;
				padding: 2px 4px;
				border-radius: 3px;
				background: lighten(#5bc0de, 10);
				color: #286b86;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// application/views/commons/menu.vue?167c2f35